export enum SubscriptionPlan {
    Free,
    Basic,
    Standard,
    Business
}
